import { FocusedFeatureTypes } from 'common/types'
import { assertUnreachable } from 'utils/unreachable'

/**
 * How wide a card a participant answers in may grow on their laptop: a
 * comfortable line length, not the whole screen.
 */
export const ANSWER_CARD_MAX_WIDTH_PX = 880

/**
 * Whether the participant's laptop shows this tool as one card to answer in,
 * which the stage centres at `ANSWER_CARD_MAX_WIDTH_PX`.
 *
 * Everything else brings its own width or its own centring: slides and the
 * screen share fill the stage, the list poll lays its questions side by side
 * and is symmetrical already, and the tools the projector shows alone are a
 * centred note.
 *
 * Exhaustive on purpose: a new tool has to be put on one side or the other.
 */
export const isAnswerCard = (type: FocusedFeatureTypes): boolean => {
	switch (type) {
		case FocusedFeatureTypes.POLLING_MULTIPLE_CHOICE:
		case FocusedFeatureTypes.POLLING_OPEN_ENDED_WORD_CLOUD:
		case FocusedFeatureTypes.ICEBREAKER:
		case FocusedFeatureTypes.KNOWLEDGE_CHECK:
			return true
		case FocusedFeatureTypes.POLLING_OPEN_ENDED_LIST:
		case FocusedFeatureTypes.SLIDE:
		case FocusedFeatureTypes.ScreenShare:
		case FocusedFeatureTypes.WHITEBOARD:
		case FocusedFeatureTypes.NOTEPAD:
		case FocusedFeatureTypes.GROUPING:
		case FocusedFeatureTypes.SIMPLE_GROUPING:
		case FocusedFeatureTypes.AUDIO_STREAMING:
		case FocusedFeatureTypes.YOUTUBE_STREAMING:
			return false
		default:
			return assertUnreachable('FocusedFeatureTypes', type)
	}
}
